import axios from 'axios';

const state = {
    autotext: "",
};

const getters = {

};

const actions = {
    autotext_list({ commit }, data) {
        return new Promise((resolve, reject) => { 
            axios.get('cs-management/autotext', { params: data })
            .then(response => {
                commit("PUSH_AUTOTEXT", "OK")
                resolve(response)
            })
            .catch(err => {
                reject(err)
          })
        })
    },
    autotext_search({ commit }, data) {
        return new Promise((resolve, reject) => { 
            axios.get('cs-management/autotext/search', { params: { q: data } })
            .then(response => {
                commit("PUSH_AUTOTEXT", "OK")
                resolve(response)
            })
            .catch(err => {
                reject(err)
          })
        })
    },
    autotext_create({ commit }, data) {
        return new Promise((resolve, reject) => { 
            axios.post('cs-management/autotext', data)
            .then(response => {
                commit("PUSH_AUTOTEXT", "OK")
                resolve(response)
            })
            .catch(err => {
                reject(err)
          })
        })
    },
    autotext_detail({ commit }, data) {
        return new Promise((resolve, reject) => { 
            axios.get('cs-management/autotext/' + data.id)
            .then(response => {
                commit("PUSH_AUTOTEXT", "OK")
                resolve(response)
            })
            .catch(err => {
                reject(err)
          })
        })
    },
    autotext_update({ commit }, data) {
        return new Promise((resolve, reject) => { 
            axios.put('cs-management/autotext/' + data.id, data)
            .then(response => {
                commit("PUSH_AUTOTEXT", "OK")
                resolve(response)
            })
            .catch(err => {
                reject(err)
          })
        })
    },
    autotext_delete({ commit }, data) {
        return new Promise((resolve, reject) => { 
            axios.delete('cs-management/autotext/' + data.id)
            .then(response => {
                commit("PUSH_AUTOTEXT", "OK")
                resolve(response)
            })
            .catch(err => {
                reject(err)
          })
        })
    },
}

const mutations = {
    PUSH_AUTOTEXT(state, data){
        state.autotext = data
    },
};


export default {
  state,
  getters,
  actions,
  mutations
};